module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-7-38c696992c680b657bb28a27d8ad02a9.jpg";